import React from 'react';

import { useGoogleAnalyticsAndTagManager } from '../../hooks/useGoogleAnalyticsAndTagManager';

export const GoogleAnalyticsAndTagManager: React.FC = () => {
    useGoogleAnalyticsAndTagManager();
    return null;
};
